import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const WelcomeBonusModal = ({ show, onHide }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="welcome-bonus-modal"
            backdrop="static"
        >
            <Modal.Body className="text-center p-5">
                <div className="mb-4 d-flex justify-content-center">
                    <div className="rounded-full" style={{ width: '100px', height: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="65"
                            height="65"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#a1cc3c"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <polyline points="20 12 20 22 4 22 4 12" />
                            <rect x="2" y="7" width="20" height="5" />
                            <line x1="12" y1="22" x2="12" y2="7" />
                            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
                            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
                        </svg>
                    </div>
                </div>
                <h2 className="text-2xl font-semibold mb-3">Welcome to Kaxaa eWallet!</h2>
                <p className="text-gray-600 text-lg mb-10">
                    To help you get started, we’ve dropped <b>1 POL</b> token for Polygon chain transactions into your wallet.
                </p>
                <Button
                    variant="success"
                    onClick={onHide}
                    className="modal-button primary"
                // style={{ backgroundColor: '#059669', borderColor: '#059669' }}
                >
                    Got it!
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default WelcomeBonusModal;
